import { selector } from 'lib/selectors';
import { Map } from 'immutable';

// wrong definition, takes global state

const settings = (state) => state.settings;
export const erpsSelector = selector(settings, (s) => s.erps);
export const currentERPSettingsSelector = selector(settings, (s) => s.erpSettings);
export const indexesSyncTimeFieldSelector = selector(currentERPSettingsSelector, (s) =>
  s.find(({ type }) => type === 'indexes_sync_time'),
);
export const erpIndexesSyncDateSelector = selector(indexesSyncTimeFieldSelector, (indexesSyncTimeField) =>
  indexesSyncTimeField ? indexesSyncTimeField.get('indexes_update_date') : indexesSyncTimeField,
);
export const isSyncRunningSelector = selector(indexesSyncTimeFieldSelector, (indexesSyncTimeField) =>
  indexesSyncTimeField ? indexesSyncTimeField.get('is_sync_running') : false,
);
export const canErpSyncSelector = selector(
  indexesSyncTimeFieldSelector,
  (indexesSyncTimeField) => !!indexesSyncTimeField,
);
export const isLoadingERPSettingSelector = selector(settings, (s) => s.isLoadingERPSetting);
export const hasLoadedERPSettingSelector = selector(settings, (s) => s.hasLoadedErpSettings);
export const currentERPCompaniesSelector = selector(settings, (s) => s.erpCompanies);
export const currentERPSettingsInitialValuesSelector = selector(settings, (s) =>
  s.erpSettings.reduce((acc, setting) => acc.set(setting.name, setting.value), new Map()),
);

export const getErpSettingsByName = selector(settings, (s) => {
  return s.erpSettings.toMap().mapKeys((_, record) => record.name);
});

export const isErpConnectedSelector = selector(erpsSelector, (erps) => erps.some((erp) => erp.status === 'connected'));

export const currentConnectedERPselector = selector(erpsSelector, (erps) =>
  erps.reduce((a, v, k) => (v.status === 'connected' ? k : a), null),
);

export const currentConnectedERPCompanyName = selector(erpsSelector, currentConnectedERPselector, (erps, currentERP) =>
  erps.getIn([currentERP, 'details', 'company_name']),
);

export const isRequiredErpConnectSelector = selector(
  erpsSelector,
  (erps) => !erps.some((v) => ['connected', 'connecting'].includes(v.get('status'))),
);
